<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- E200系共通部品_Steps -->
    <app-e200-steps></app-e200-steps>

    <!-- タイトル -->
    <div class="title">
      <h1>
        <label *ngIf="!confirmationFlag">分科会申請の登録</label>
        <label *ngIf="confirmationFlag">登録内容確認</label>
      </h1>
    </div>

    <!-- 分科会申請登録(E204) -->
    <div *ngIf="!confirmationFlag">
      <!-- 入力フォーム -->
      <form [formGroup]="e204InputForm">
        <!-- 分科会情報 -->
        <div class="subcommittee-information">
          <!-- 備考 -->
          <div class="note">
            <label>
              以下の項目に必要事項を記載後、分科会活動に関する個人情報の管理・運用に同意の上、「確認画面へ進む」ボタンをクリックしてください。<br/>
              <label class="warning">【必須】の項目は入力必須項目です。必ずご記載ください。
              </label>
            </label>
          </div>

          <!-- 分科会情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 申請区分 -->
              <tr>
                <td class="item-input-name">
                  申請区分
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name"></td>
                <!-- 新規登録の場合 -->
                <td class="item-information" *ngIf="'new' == inputType">
                  <p-dropdown [options]="getDicList(2025)" optionLabel="sp_name" optionValue="sp_code"
                              placeholder="選択してください" [showClear]="true" styleClass="information-Form-dropdown"
                              formControlName="appli_kbn"
                              (onChange)="formChange(e204InputForm.get('appli_kbn'))"></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('appli_kbn')">
                  </app-validator-message>
                </td>
                <!-- 編集登録の場合 -->
                <td class="item-information" *ngIf="'edit' == inputType">
                  <p-dropdown [options]="getDicList(2025)" optionLabel="sp_name" optionValue="sp_code"
                              placeholder="選択してください" [showClear]="true" styleClass="information-Form-dropdown"
                              formControlName="appli_kbn" (onChange)="formChange(e204InputForm.get('appli_kbn'))"
                              [disabled]="applikbnDisabled" [(ngModel)]="e204InputForm.value.appli_kbn"></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('appli_kbn')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 継続分科会 -->
              <tr>
                <td class="item-input-name">
                  継続分科会
                </td>
                <td class="item-label-name"></td>
                <!-- 新規登録かつ過年度から継続の場合 -->
                <td class="item-information" *ngIf="'1' == e204InputForm.get('appli_kbn').value && 'new' == inputType">
                  <p-dropdown [options]="organizerSubcommitteeList" optionLabel="theme" optionValue="subcommittee_id"
                              placeholder="選択してください" [showClear]="true" styleClass="information-Form-dropdown"
                              formControlName="continuation_id" (onChange)="viewChange()"
                              emptyMessage="データが存在しません">
                  </p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('continuation_id')">
                  </app-validator-message>
                </td>
                <!-- 編集かつ過年度から継続の場合 -->
                <td class="item-information"
                    *ngIf="'1' == e204InputForm.get('appli_kbn').value && 'edit' == inputType">
                  <input type="text" pInputText class="information-Form-continuation"
                         formControlName="continuation_theme"
                         disabled/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('continuation_theme')">
                  </app-validator-message>
                </td>
                <!-- 上記以外の場合 -->
                <td class="item-information"
                    *ngIf="('1' != e204InputForm.get('appli_kbn').value && 'new' == inputType ) ||('1' != e204InputForm.get('appli_kbn').value && 'edit' == inputType )">
                  <p-dropdown [options]="organizerSubcommitteeList" optionLabel="theme" optionValue="subcommittee_id"
                              placeholder="選択してください" [showClear]="true" styleClass="information-Form-dropdown"
                              formControlName="continuation_id" (onChange)="viewChange()"
                              emptyMessage="データが存在しません"
                              [disabled]="subcommitteeDisabled"
                              [(ngModel)]="e204InputForm.value.continuation_id"></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('continuation_id')">
                  </app-validator-message>
                </td>
              </tr>

              <div class="sub-title">
                <h2>分科会の概要</h2>
              </div>
              <!-- 提案テーマ -->
              <tr>
                <td class="item-input-name">
                  提案テーマ
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <!-- 新規登録かつ新規の分科会の場合 -->
                <td class="item-information" *ngIf="'1' != e204InputForm.get('appli_kbn').value">
                  <div class="warning-text">
                    ※前年度の継続申請は、タイトルの変更ができません
                  </div>
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="theme"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('theme')">
                  </app-validator-message>
                </td>
                <!-- 編集登録または過年度から継続の場合 -->
                <td class="item-information" *ngIf="'1' == e204InputForm.get('appli_kbn').value">
                  <div class="warning-text">
                    ※前年度の継続申請は、タイトルの変更ができません
                  </div>
                  <input type="text" pInputText class="information-Form-inputtext-wMax" formControlName="theme"
                         disabled/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('theme')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 分科会の目的 -->
              <tr>
                <td class="item-input-name">
                  分科会の目的
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="purpose" class="p-text-area-200"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('purpose')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 解決したい課題 -->
              <tr>
                <td class="item-input-name">
                  解決したい課題
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="agenda" class="p-text-area-300"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('agenda')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 活動概要 -->
              <tr>
                <td class="item-input-name">
                  活動概要
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="outline" class="p-text-area-200"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('outline')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 活動内容１ -->
              <tr>
                <td class="item-input-name">
                  活動内容１<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="note1" class="p-text-area-300"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('note1')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 活動内容２ -->
              <tr>
                <td class="item-input-name">活動内容２</td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="note2" class="p-text-area-300"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('note2')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 活動内容３ -->
              <tr>
                <td class="item-input-name">活動内容３</td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="note3" class="p-text-area-300"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('note3')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 期待される成果 -->
              <tr>
                <td class="item-input-name">
                  期待される成果<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="outcome" class="p-text-area-200"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('outcome')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 資金・物資計画 -->
              <tr>
                <td class="item-input-name">
                  資金・物資計画<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="funding_plan" class="p-text-area-200"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('funding_plan')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 主に関連するゴール -->
              <tr>
                <td class="item-input-name">
                  主に関連するゴール<span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  達成したいゴールの番号を選択ください。<br/>
                  （複数選択可）
                  <div class="multi-line">
                    <div class="p-d-flex p-as-center checkbox-list two-line-content"
                         *ngFor="let dicData of getDicList(3)">
                      <p-checkbox name="10" [value]="dicData.sp_code"
                                  [formControl]="e204InputForm.controls['sdgs_goal']">
                      </p-checkbox>
                      <div class="checkbox-img">
                        <img [src]="dicData.sp_ext"/>
                      </div>
                      <div class="p-as-center">
                        {{ dicData.sp_code + "　" + dicData.sp_name }}
                      </div>
                    </div>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('sdgs_goal')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 計画書概要 -->
              <tr>
                <td class="item-input-name">
                  計画書概要
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  「資料一覧」の「
                  <a href="./data/s08-2_sesssion_planning.pptx"
                     target="_blank">
                    分科会実施計画書ひながた（概要）
                    <i class="pi pi-clone"></i> </a>」を記載の上、PDFファイルに変換してアップロードしてください。<br/>
                  ファイル容量は10MBまでです。
                  <p-fileUpload #fileUpload [chooseLabel]="'ファイルを選択'" [cancelLabel]="'キャンセル'"
                                [showUploadButton]="false"
                                fileLimit="1" (onSelect)="uploadFile($event, fileUpload)" (onRemove)="deleteFile()"
                                (onClear)="deleteFile()">
                    <ng-template pTemplate="content">
                      <div class="p-fileupload-files ng-star-inserted" *ngIf="image">
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div class="image"></div>
                            <div>{{ fileName }}</div>
                            <div></div>
                            <div>
                              <button type="button" icon="pi pi-times" pbutton="" ng-reflect-icon="pi pi-times"
                                      class="p-button p-component p-button-icon-only" (click)="deleteFile()">
                                <span class="p-button-icon pi pi-times" aria-hidden="true"></span>
                                <span aria-hidden="true" class="p-button-label">&nbsp;</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-fileUpload>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('image')">
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>参加メンバーへの期待</h2>
          </div>
          <!-- 分科会情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 参加してほしいメンバー -->
              <tr>
                <td class="item-input-name">
                  参加してほしいメンバー
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="members_who_want" class="p-text-area-200"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('members_who_want')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 想定しているメンバー数 -->
              <tr>
                <td class="item-input-name">
                  想定しているメンバー数
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="members_count" class="p-text-area-100"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('members_count')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- メンバーへの期待 -->
              <tr>
                <td class="item-input-name">
                  メンバーへの期待
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="members_expectation" class="p-text-area-200"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('members_expectation')">
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>実施スケジュール</h2>
          </div>
          <!-- 分科会情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 実施スケジュール -->
              <tr>
                <td class="item-input-name">
                  実施スケジュール
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea placeholder="記載例）
4- 6月：活動計画の策定(4月)、活動説明会の実施(5月)、オンライン会議の実施(5,6月)
7- 9月：オンライン会議の実施(7,8,9月)、分科会参加企業・地方公共団体によるプレゼンテーション(7,8,9月)
10-12月：オンライン会議の実施(10,11,12月)、分科会参加企業・地方公共団体によるプレゼンテーション(10,11,12月)
1- 3月：分科会参加企業・地方公共団体による成果検討・共有会議(1,2月)、活動報告書作成・提出(2,3月)"
                            formControlName="schedule" class="p-text-area-300"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('schedule')">
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>その他特記事項</h2>
          </div>
          <!-- 分科会情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- その他特記事項 -->
              <tr>
                <td class="item-input-name">その他特記事項</td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <textarea pInputTextarea formControlName="note" class="p-text-area-200"></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('note')">
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="information-margin-height"></div>

          <!-- サブタイトル -->
          <div class="sub-title">
            <h2>主催・窓口</h2>
          </div>
          <!-- 分科会情報内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 主催（団体名称） -->
              <tr>
                <td class="item-input-name">
                  主催（団体名称）
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="organizer_group_name"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('organizer_group_name')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 主催（部署名） -->
              <tr>
                <td class="item-input-name">
                  主催（部署名）
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="organizer_divition_name"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('organizer_divition_name')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 主催（担当者名） -->
              <tr>
                <td class="item-input-name">
                  主催（担当者名）
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="organizer_person_name"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('organizer_person_name')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 主催（電話番号） -->
              <tr>
                <td class="item-input-name">主催（電話番号）</td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="organizer_tel"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('organizer_tel')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 主催（eメールアドレス） -->
              <tr>
                <td class="item-input-name">
                  主催（eメールアドレス）
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="organizer_email"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('organizer_email')">
                  </app-validator-message>
                </td>
              </tr>

              <!-- 窓口（団体名称） -->
              <tr>
                <td class="item-input-name">窓口（団体名称）</td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="reception_group_name"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('reception_group_name')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 窓口（部署名） -->
              <tr>
                <td class="item-input-name">窓口（部署名）</td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="reception_divition_name"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('reception_divition_name')">
                  </app-validator-message>
                </td>
              </tr>
              <!--窓口（担当者名） -->
              <tr>
                <td class="item-input-name">窓口（担当者名）</td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="reception_person_name"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('reception_person_name')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 窓口（電話番号） -->
              <tr>
                <td class="item-input-name">窓口（電話番号）</td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="reception_tel"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('reception_tel')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 窓口（eメールアドレス） -->
              <tr>
                <td class="item-input-name">窓口（eメールアドレス）</td>
                <td class="item-label-name">
                  <p-tag value="会員限定公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText class="information-Form-inputtext-wMax"
                         formControlName="reception_email"/>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="e204InputForm.get('reception_email')">
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </form>

      <!-- 管理・運用チェック -->
      <div class="p-d-flex p-jc-center" *ngIf="'new' == inputType">
        <div class="p-as-center ruleCheck">
          分科会活動で得た個人情報について、以下のとおり適正かつ安全に管理・運用すること<br>
          <span class="ruleCheckText">１.分科会運営以外の目的での利用及び第三者への提供は行わないこと<br></span>
          <span class="ruleCheckText">２.分科会活動終了後、遅滞なく、適切に破棄すること<br></span>
          <span class="ruleCheckText">３.「主催・窓口」として自動登録される全てのユーザーに対して、必要かつ適切な管理を行うこと<br></span>
          <span class="ruleCheckText">４.「主催・窓口」に変更したユーザーに対して、必要かつ適切な管理を行うこと</span>
        </div>
      </div>
      <div class="p-d-flex p-jc-center" *ngIf="'new' == inputType">
        <p-checkbox [value]="true" label="上記に同意の上、分科会の設置を申請します。"
                    [(ngModel)]="ruleCheckFlag"></p-checkbox>
      </div>

      <!-- ヴァリデーションチェックメッセージエリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="((!ruleCheckFlag.length || !e204InputForm.valid) && 'new' == inputType)
          || (!e204InputForm.valid && 'new' != inputType)">
        <label class="warning platform-warning-text">
          未入力の項目、またはエラーがあります。
        </label>
      </div>
      <div class="p-d-flex p-jc-center error-area" *ngIf="(ruleCheckFlag.length && e204InputForm.valid && 'new' == inputType )
          || (e204InputForm.valid && 'new' != inputType)">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="確認画面へ進む" class="button-default-size button1" (click)="moveE205()"
                [disabled]="((!ruleCheckFlag.length || !e204InputForm.valid ) && 'new' == inputType)
            || (!e204InputForm.valid && 'new' != inputType)"></button>
      </div>
    </div>

    <!------------------------------------------------------------------------->

    <!-- 分科会申請登録確認(E205) -->
    <div *ngIf="confirmationFlag">
      <!-- 分科会情報 -->
      <div class="subcommittee-information">
        <!-- 備考 -->
        <div class="note">
          下記内容でよろしければ、「登録する」ボタンを押して下さい。
        </div>

        <!-- 申請情報 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 申請区分 -->
            <tr>
              <td class="item-name">
                申請区分
              </td>
              <td class="item-information" *ngIf="'1' != e204InputForm.value.appli_kbn">
                新規
              </td>
              <td class="item-information" *ngIf="'1' == e204InputForm.value.appli_kbn">
                継続
              </td>
            </tr>
            <!-- 継続分科会 -->
            <tr>
              <td class="item-name">
                継続分科会
              </td>
              <!-- 申請区分が新規の場合 -->
              <td class="item-information"
                  *ngIf="'1' != e204InputForm.value.appli_kbn || ('1' == e204InputForm.value.appli_kbn && 'new' == inputType)">
                <div *ngFor="let dicName of organizerSubcommitteeList">
                  <div *ngIf="e204InputForm.value.continuation_id == dicName.subcommittee_id">
                    {{ dicName['theme'] }}
                  </div>
                </div>
              </td>
              <!-- 申請区分が継続の場合 -->
              <td class="item-information" *ngIf="'1' == e204InputForm.value.appli_kbn && 'edit' == inputType">
                {{ e204InputForm.value.continuation_theme }}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>分科会の概要</h2>
        </div>
        <!-- 分科会情報内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 提案テーマ -->
            <tr>
              <td class="item-name">
                提案テーマ
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.theme }}
              </td>
            </tr>

            <!-- 分科会の目的 -->
            <tr>
              <td class="item-name">
                分科会の目的
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.purpose }}
              </td>
            </tr>
            <!-- 解決したい課題 -->
            <tr>
              <td class="item-name">
                解決したい課題
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.agenda }}
              </td>
            </tr>
            <!-- 活動概要 -->
            <tr>
              <td class="item-name">
                活動概要
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.outline }}
              </td>
            </tr>
            <!-- 活動内容１ -->
            <tr>
              <td class="item-name">
                活動内容１
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.note1 }}
              </td>
            </tr>
            <!-- 活動内容２ -->
            <tr>
              <td class="item-name">活動内容２</td>
              <td class="item-information">
                {{ e204InputForm.value.note2 }}
              </td>
            </tr>
            <!-- 活動内容３ -->
            <tr>
              <td class="item-name">活動内容３</td>
              <td class="item-information">
                {{ e204InputForm.value.note3 }}
              </td>
            </tr>
            <!-- 期待される成果 -->
            <tr>
              <td class="item-name">
                期待される成果<span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.outcome }}
              </td>
            </tr>
            <!-- 資金・物資計画 -->
            <tr>
              <td class="item-name">
                資金・物資計画<span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.funding_plan }}
              </td>
            </tr>
            <!-- 主に関連するゴール -->
            <tr>
              <td class="item-name">
                主に関連するゴール<span class="required">【必須】</span>
              </td>
              <td class="item-information">
                <div class="p-d-flex p-as-center checkbox-list" *ngFor="
                    let dicName of getDicNameList(
                      3,
                      e204InputForm.value.sdgs_goal
                    )
                  ">
                  <div class="checkbox-img">
                    <img [src]="dicName.sp_ext"/>
                  </div>
                  <div class="p-as-center">
                    {{ dicName.sp_code }}　{{ dicName.sp_name }}
                  </div>
                </div>
              </td>
            </tr>
            <!-- 計画書概要 -->
            <tr>
              <td class="item-name">
                計画書概要
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">{{ fileName }}</td>
            </tr>
          </ng-template>
        </p-table>

        <div class="information-margin-height"></div>

        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>参加メンバーへの期待</h2>
        </div>
        <!-- 分科会情報内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 参加してほしいメンバー -->
            <tr>
              <td class="item-name">
                参加してほしいメンバー
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.members_who_want }}
              </td>
            </tr>
            <!-- 想定しているメンバー数 -->
            <tr>
              <td class="item-name">
                想定しているメンバー数
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.members_count }}
              </td>
            </tr>
            <!-- メンバーへの期待 -->
            <tr>
              <td class="item-name">
                メンバーへの期待
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.members_expectation }}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div class="information-margin-height"></div>

        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>実施スケジュール</h2>
        </div>
        <!-- 分科会情報内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 実施スケジュール -->
            <tr>
              <td class="item-name">
                実施スケジュール
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.schedule }}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div class="information-margin-height"></div>

        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>その他特記事項</h2>
        </div>
        <!-- 分科会情報内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- その他特記事項 -->
            <tr>
              <td class="item-name">その他特記事項</td>
              <td class="item-information">
                {{ e204InputForm.value.note }}
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div class="information-margin-height"></div>

        <!-- サブタイトル -->
        <div class="sub-title">
          <h2>主催・窓口</h2>
        </div>
        <!-- 分科会情報内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 主催（団体名称） -->
            <tr>
              <td class="item-name">
                主催（団体名称）
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.organizer_group_name }}
              </td>
            </tr>
            <!-- 主催（部署名） -->
            <tr>
              <td class="item-name">
                主催（部署名）
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.organizer_divition_name }}
              </td>
            </tr>
            <!-- 主催（担当者名） -->
            <tr>
              <td class="item-name">
                主催（担当者名）
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.organizer_person_name }}
              </td>
            </tr>
            <!-- 主催（電話番号） -->
            <tr>
              <td class="item-name">主催（電話番号）</td>
              <td class="item-information">
                {{ e204InputForm.value.organizer_tel }}
              </td>
            </tr>
            <!-- 主催（eメールアドレス） -->
            <tr>
              <td class="item-name">
                主催（eメールアドレス）
                <span class="required">【必須】</span>
              </td>
              <td class="item-information">
                {{ e204InputForm.value.organizer_email }}
              </td>
            </tr>

            <!-- 窓口（団体名称） -->
            <tr>
              <td class="item-name">窓口（団体名称）</td>
              <td class="item-information">
                {{ e204InputForm.value.reception_group_name }}
              </td>
            </tr>
            <!-- 窓口（部署名） -->
            <tr>
              <td class="item-name">窓口（部署名）</td>
              <td class="item-information">
                {{ e204InputForm.value.reception_divition_name }}
              </td>
            </tr>
            <!-- 窓口（担当者名） -->
            <tr>
              <td class="item-name">窓口（担当者名）</td>
              <td class="item-information">
                {{ e204InputForm.value.reception_person_name }}
              </td>
            </tr>
            <!-- 窓口（電話番号） -->
            <tr>
              <td class="item-name">窓口（電話番号）</td>
              <td class="item-information">
                {{ e204InputForm.value.reception_tel }}
              </td>
            </tr>
            <!-- 窓口（eメールアドレス） -->
            <tr>
              <td class="item-name">窓口（eメールアドレス）</td>
              <td class="item-information">
                {{ e204InputForm.value.reception_email }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <!-- 余白エリア -->
      <div class="p-d-flex p-jc-center error-area">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="登録する" class="button-default-size button1"
                (click)="moveE206()"></button>
        <button pButton type="button" label="修正する" class="button-default-size button2"
                (click)="moveE204()"></button>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
